module.exports = __webpack_public_path__ + "img/d4.52bb2a9b.png";